import { combineReducers } from "redux"
import actionTypes from "#/redux/actions/actionTypes"
import { createIsLoadedReducer, createReducer } from "./shared"

const {
  FETCH_INSURANCE_SYNC_SUCCESS,
  FETCH_REIMBURSEMENT_DETAILS_SUCCESS,
  FETCH_REIMBURSEMENT_DETAILS_STATUS,
  FETCH_REIMBURSEMENT_DETAILS_ENROLLMENT_STARTED
} = actionTypes

const reducers = {}

// @ts-expect-error TS(2339) FIXME: Property 'loaded' does not exist on type '{}'.
reducers.loaded = createIsLoadedReducer("FETCH_INSURANCE_SYNC")

// insurance sync
// @ts-expect-error TS(2339) FIXME: Property 'availableTradingPartners' does not exist... Remove this comment to see the full error message
reducers.availableTradingPartners = createReducer(null, {
  [FETCH_INSURANCE_SYNC_SUCCESS]: (state: any, action: any) => action.response.tradingPartners.availableTradingPartners
})

const insuranceSyncInfo = combineReducers(reducers)

// insurance sync
export const getInsuranceSyncInfo = (state: any) => state.insuranceSyncInfo

export default insuranceSyncInfo

// reimbursement details
const reimbursementDetailsReducers = {
  loaded: createIsLoadedReducer("FETCH_REIMBURSEMENT_DETAILS_SYNC"),
  reimbursementDetails: createReducer(null, {
    [FETCH_REIMBURSEMENT_DETAILS_SUCCESS]: (state: any, action: any) => action.response
  }),
  reimbursementDetailsStatus: createReducer(null, {
    [FETCH_REIMBURSEMENT_DETAILS_STATUS]: (state: any, action: any) => action.status
  }),
  // Used only by the enrollment flow
  enrollmentFlowRequestStarted: createReducer(false, {
    [FETCH_REIMBURSEMENT_DETAILS_ENROLLMENT_STARTED]: (state: any, action: any) => action.startedEnrollment
  })
}

// This is some weird wiring thing. Not worth trying to unwind right now.
export const getReimbursementDetails = (state: any) => state.reimbursementDetails.reimbursementDetails
export const getReimbursementDetailsStatus = (state: any) => state.reimbursementDetails.reimbursementDetailsStatus
export const getEnrollmentFlowRequestStarted = (state: any) => state.reimbursementDetails.enrollmentFlowRequestStarted

export const reimbursementDetails = combineReducers(reimbursementDetailsReducers)
